import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import {
    TextField,
    IconButton,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import { textFieldStyle } from 'shared/TextStepField/TextStepField.style'
import PictureLayout from 'shared/PictureLayout/PictureLayout'
import styles from './CommentPicture.style'

const propTypes = {
    image: PropTypes.string.isRequired,
    id: PropTypes.number,
    step: PropTypes.shape({
        isCommentable: PropTypes.bool.isRequired,
        isRequired: PropTypes.bool.isRequired,
        isAnswered: PropTypes.bool.isRequired,
    }).isRequired,
    comment: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isNested: PropTypes.bool,
    isSummaryView: PropTypes.bool,
}

const CommentPicture = ({
    image,
    id,
    step,
    comment,
    onChange,
    onDelete,
    isNested = false,
    isSummaryView = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)
    const textFieldStyles = useStyle(textFieldStyle)

    const onTextChange = useCallback((event) => {
        onChange(event.target.value)
    }, [onChange])

    return (

        <PictureLayout
            title={step.isCommentable ? t('ADD_COMMENT') : t('PICTURE')}
            image={image}
            isRequired={step.isRequired}
            isAnswered
            isNested={isNested}
            isSummaryView={isSummaryView}
        >
            <div
                css={classes.context}
            >
                { step.isCommentable ? (
                    <TextField
                        css={classes.text}
                        id="outlined-helperText"
                        value={comment}
                        fullWidth
                        multiline
                        rows={10}
                        size="small"
                        sx={textFieldStyles}
                        variant="outlined"
                        onChange={onTextChange}
                        disabled={Boolean(id)}
                    />
                ) : <div css={classes.emptyCommentAria} />}
                <IconButton
                    aria-label="delete"
                    data-testid="delete-picture-button"
                    size="medium"
                    css={classes.deleteButton}
                    onClick={onDelete}
                >
                    <DeleteIcon fontSize="large" />
                </IconButton>
            </div>
        </PictureLayout>

    )
}

CommentPicture.propTypes = propTypes

export default CommentPicture
